import axios from 'axios';
import constants from '../constants';

const OBJECTS_PATH = constants.urlPrefix + '/api/objects';
const ITEMS_PATH = OBJECTS_PATH + '/items';
const OBJECTS_AND_ITEMS_PATH = OBJECTS_PATH + '/moitems'

const getMenuObjects = () =>  axios.get(OBJECTS_PATH);
const getDesignMenuItems = (designId) =>  axios.get(ITEMS_PATH, { params: { designId }});
const getDesignMenuObjectsAndItems = (designId) =>  axios.get(OBJECTS_AND_ITEMS_PATH, { params: { designId }});

export default {
    getMenuObjects,
    getDesignMenuItems,
    getDesignMenuObjectsAndItems
}
